import { Action } from '@ngrx/store';

export * from '../announcements/announcements.actions';
export * from '../auth/auth.actions';
export * from '../chats/chats.actions';
export * from '../check-in-tags/check-in-tags.actions';
export * from '../check-ins/check-ins.actions';
export * from '../conversations/conversations.actions';
export * from '../core/core.actions';
export * from '../customer-files/customer-files.actions';
export * from '../customer-team/customer-team.actions';
export * from '../customer-lists/customer-lists.actions';
export * from '../customers/customers.actions';
export * from '../feed/feed.actions';
export * from '../feedback/feedback.actions';
export * from '../file-upload/file-upload.actions';
export * from '../files/files.actions';
export * from '../invite/invite.actions';
export * from '../location/location.actions';
export * from '../memo-categories/memo-categories.actions';
export * from '../memoriams/memoriams.actions';
export * from '../memos/memos.actions';
export * from '../member-badges/member-badges.actions';
export * from '../market-management-category/market-management-category.actions';
export * from '../notifications/notifications.actions';
export * from '../organisations/organisations.actions';
export * from '../profile/profile.actions';
export * from '../remote-config/remote-config.actions';
export * from '../requests/requests.actions';
export * from '../router/router.actions';
export * from '../settings/settings.actions';
export * from '../snackbar/snackbar.actions';
export * from '../staff-customers/staff-customers.actions';
export * from '../members/members.actions';
export * from '../statistics/statistics.actions';
export * from '../storage-sync/storage-sync.actions';
export * from './bulk-request.actions';
export * from './reset.actions';
export * from '../tenants/tenants.actions';

export const NETWORK_ERROR = '[Network] error';

export class CAAction implements Action {
  readonly type: string;
  public payload: any;
}

export class NetworkError implements Action {
  readonly type = NETWORK_ERROR;
  constructor(public payload: any) {}
}
